export default __webpack_public_path__ + "static/media/Skills.d56db8b5.PNG";